import { Tag } from "@carbon/react";
import { OverflowMenuVertical } from "@carbon/react/icons";

import { paymentLinkStatus } from "../../enums";
import { formatAsCurrency } from "../../utils";

export const paymentLinkDisplayFormatter = (item) => {
  const statusIndicator =
    item.status === paymentLinkStatus.active
      ? { statusText: "Active", statusType: "green" }
      : { statusText: "Deactivated", statusType: "gray" };

  return {
    ...item,
    price: (
      <strong>
        {item.currencySymbol} {formatAsCurrency(item.price)}
      </strong>
    ),
    status: (
      <Tag className="transaction-status" type={statusIndicator.statusType}>
        <span>{statusIndicator.statusText}</span>
        <div
          style={{ backgroundColor: statusIndicator.statusType }}
          className="status-indicator"
        />
      </Tag>
    ),
    product: <strong>{item.productName}</strong>,
    description: <strong>{item.description}</strong>,
    date: <span className="date--oneline">{item.date}</span>,
    more: <OverflowMenuVertical />,
  };
};
